import { createFileRoute } from '@tanstack/react-router'
import OrganisationHolidayPageHeader from '../../Pages/OrganisationHolidaysPage/OrganisationHolidayPageHeader'
import OrganisationHolidaysPage from '../../Pages/OrganisationHolidaysPage/OrganisationHolidaysPage'
import PageBody from '../../Pages/Layout/PageBody'
import { processTRPCData } from '../../Queries/fetchData'
import LoadingSpinner from '../../Components/LoadingSpinner'
import ErrorComponent from '../../Components/ErrorComponent'
import {
    canViewRoute,
    migratedToV2,
} from '../../State/Permissions/HasPermissions'
import SessionStore from '../../State/SessionStore'
import PermissionDenied from '../../Pages/PermissionDenied'
import { CenterPadPageBody } from '@2/layout/page-body'
import { setLayoutDefaults } from '@2/layout/layout-store'
import {
    setIsLoading,
    setHolidays,
    setPendingChanges,
    getHolidays,
    usePendingChanges,
} from '../../version2/pages/organisation-holidays/organistion-holiday-store'
import { trpc } from '@/system/trpc'
import { holidayStore } from '../../version2/pages/organisation-holidays/organistion-holiday-store'
import { OrganisationHolidaysPage as OrganisationHolidaysPageV2 } from '../../version2/pages/organisation-holidays/organistion-holiday-page'
import { PageBody as V2PageBody } from '@2/layout/page-body'

export const Route = createFileRoute('/_private/organisation-holidays')({
    beforeLoad: ({ params }) => {
        if (!canViewRoute(SessionStore.user, 'organisationHolidays', params))
            throw new Error('Permission Denied')
        setLayoutDefaults({
            pageTitle: 'Organisation Holidays',
            subMenu: 'organisation',
        })
    },
    errorComponent: ({ error, reset }) => {
        if (error.message === 'Permission Denied') return <PermissionDenied />
        return <ErrorComponent error={error} reset={reset} />
    },
    loader: async () => {
        const data = await trpc.legacy.getOrganisationHolidaysPageData.query()
        return processTRPCData(data)
    },
    pendingComponent: LoadingSpinner,
    component: Wrapper,
})

function Wrapper() {
    // The store now handles all the save toast logic internally
    holidayStore.useSaveHandler()

    if (migratedToV2()) {
        return (
            <V2PageBody>
                <OrganisationHolidaysPageV2 />
            </V2PageBody>
        )
    }

    return (
        <>
            <OrganisationHolidayPageHeader />
            <PageBody>
                <OrganisationHolidaysPage />
            </PageBody>
        </>
    )
}
